import React from 'react';
import VitalCard from '../ui/VitalCard.jsx';
import AvatarStack from '../ui/AvatarStack.jsx';
import { fmtHours } from '../../utils/formatters.js';
import Skeleton from '../ui/Skeleton.jsx';

export default function VitalSigns({ project, loadingRedmine = false, redmineError = false, onSyncRedmine = null }) {
  const team = project.active_team || [];
  const managersHeading = (
    <h3 className="text-[11px] uppercase tracking-wider mb-2" style={{ color: '#9A9A95', letterSpacing: '0.08em' }}>
      Managers
    </h3>
  );

  return (
    <section id="vital-signs" style={{ scrollMarginTop: 80 }}>
      <h2 className="text-[11px] uppercase tracking-wider mb-3" style={{ color: '#9A9A95', letterSpacing: '0.08em' }}>Vital signs</h2>
      <div className="grid grid-cols-2 gap-3">
        <VitalCard
          label="Hours this month"
          big={loadingRedmine ? <Skeleton width={64} height={26} /> : (redmineError ? '—' : fmtHours(project.hours_mtd))}
          sub={redmineError ? 'Unavailable' : (
            <>
              <div>
                Pulled from <span style={{ color: '#3A3A38' }}>Redmine</span>
                {project.redmine_url && (
                  <>
                    {' · '}
                    <a
                      href={project.redmine_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#3A3A38', textDecoration: 'none', fontWeight: 500 }}
                    >Open in Redmine →</a>
                  </>
                )}
              </div>
              {onSyncRedmine && (
                <button
                  type="button"
                  onClick={onSyncRedmine}
                  disabled={loadingRedmine}
                  className="mt-2 text-[11.5px] px-2 py-1 rounded-md border"
                  style={{
                    borderColor: '#E0DFD9', background: '#fff',
                    color: loadingRedmine ? '#9A9A95' : '#1A1A1A',
                    cursor: loadingRedmine ? 'not-allowed' : 'pointer'
                  }}
                >{loadingRedmine ? 'Syncing…' : '⟳ Sync with Redmine'}</button>
              )}
            </>
          )}
        />
        <VitalCard
          label="Team"
          big={loadingRedmine ? <Skeleton width={28} height={26} /> : (redmineError ? '—' : String(team.length))}
          chart={loadingRedmine
            ? <Skeleton width={120} height={22} radius={999} />
            : (redmineError ? null : <AvatarStack engineers={team} max={6} size={22} />)}
          sub={loadingRedmine
            ? <Skeleton width={90} height={12} />
            : (redmineError ? 'Unavailable' : <>{team.length} active members</>)}
        />
      </div>

      {loadingRedmine ? (
        <div style={{ marginTop: 16 }}>
          {managersHeading}
          <div className="flex items-center gap-3">
            <Skeleton width={22} height={22} radius={999} />
            <Skeleton width={160} height={13} />
          </div>
        </div>
      ) : (!redmineError && (project.managers || []).length > 0 && (
        <div style={{ marginTop: 16 }}>
          {managersHeading}
          <div className="flex items-center gap-3">
            <AvatarStack engineers={project.managers} max={6} size={22} />
            <div style={{ fontSize: 12.5, color: '#3A3A38' }}>
              {project.managers.map(m => m.name).join(', ')}
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}
